import { createSelector } from 'reselect'

export const getAdditionalDependencies = createSelector(
  (state) => state && state.categories && state.categories.additionalDependencies
    ? state.categories.additionalDependencies : {},
  (additionalDependencies) => additionalDependencies
)
